import {
    EVENT_SHOW_ERROR,
    EVENT_SHOW_SUCCESS,
    EVENTS_SHOW_ERROR,
    EVENTS_SHOW_SUCCESS
} from '../actions/event';

import first from 'lodash.first';
import keyBy from 'lodash.keyby';

const defaultState = {
    loading: true,
    startListColumns: {},
    leaderboardColumns: {},
    leaderboardDetails: {}
};

export default (state = defaultState, { type, payload }) => {
    switch (type) {
        case EVENTS_SHOW_ERROR:
        case EVENT_SHOW_ERROR: {
            return {
                startListColumns: {},
                leaderboardColumns: {},
                leaderboardDetails: {}
            };
        }

        case EVENTS_SHOW_SUCCESS:
        case EVENT_SHOW_SUCCESS: {
            if (payload && payload.length) {
                const event = first(payload) || {};

                return {
                    ...event,
                    startListColumns: keyBy(
                        event.startListColumns,
                        (value) => value
                    ),
                    leaderboardColumns: keyBy(
                        event.leaderboardColumns,
                        (value) => value
                    ),
                    leaderboardDetails: keyBy(
                        event.leaderboardDetails,
                        (value) => value
                    )
                };
            }

            return {};
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/event.js